import { render, staticRenderFns } from "./ComprehensivePrivacyNotice.vue?vue&type=template&id=4487459b&scoped=true"
import script from "./ComprehensivePrivacyNotice.vue?vue&type=script&lang=js"
export * from "./ComprehensivePrivacyNotice.vue?vue&type=script&lang=js"
import style0 from "./ComprehensivePrivacyNotice.vue?vue&type=style&index=0&id=4487459b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4487459b",
  null
  
)

export default component.exports